/** Platform roles (Cognito groups), same names as the backend. */
export const ROLES = ["platform-admin", "tenant-admin", "analyst", "viewer"] as const;
export type Role = (typeof ROLES)[number];

/** GET /v1/me */
export interface Me {
  id: string;
  email: string | null;
  emailVerified: boolean;
  name: string | null;
  groups: string[];
  /** Client the user belongs to; null until a platform admin assigns one. */
  tenantId: string | null;
  /** Pages the user may open (their access groups; all for platform admins). */
  modules: string[];
}

export type AuthStatus = "loading" | "signedIn" | "signedOut";
